export default {"src":"/_next/static/media/parkinglot-color.8f34f255.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};